import React from 'react';
import ReactEcharts from 'echarts-for-react';
import PropTypes from 'prop-types';

function GraphGroups (props) {
  const { members, typeDisplay } = props.el;
  let reports = [];
  const rpts = props.reports.slice();

  if (typeDisplay && typeDisplay !== 'ALL' && members) {
    reports = rpts.filter(rpt => members.includes(rpt._id));
  } else {
    reports = [...rpts];
  }

  const groups = reports.reduce((result, group) => {
    const {
      _id,
      name,
      number,
      received,
      answered,
      lost,
      queue,
      ringing,
      leaved,
      notAnswered,
      hqueued
    } = group;
    if (Object.keys(result).includes(_id)) {
      result[_id].labels = result[_id].labels.concat(['']);
      result[_id].series.answered = result[_id].series.answered.concat([
        answered
      ]);
      result[_id].series.lost = result[_id].series.lost.concat([lost]);
      result[_id].series.queue = result[_id].series.queue.concat([queue]);
      result[_id].series.ringing = result[_id].series.ringing.concat([ringing]);
      result[_id].series.leaved = result[_id].series.leaved.concat([leaved]);
      result[_id].series.notAnswered = result[_id].series.notAnswered.concat([
        notAnswered
      ]);
      result[_id].series.hqueued = result[_id].series.hqueued.concat([hqueued]);
    } else {
      result[_id] = {};
      result[_id].title = `${number} - ${name} | RCB: ${received}`;
      result[_id].labels = [''];
      result[_id].received = parseInt(received, 10);
      result[_id].series = {
        answered: [answered],
        lost: [lost],
        queue: [queue],
        ringing: [ringing],
        leaved: [leaved],
        notAnswered: [notAnswered],
        hqueued: [hqueued]
      };
    }
    return result;
  }, {});

  return (
    <div>
      {Object.keys(groups).map((_id, i) => {
        const type = 'bar';

        const label = {
          normal: {
            show: true,
            position: 'insideBottom',
            fontSize: 16,
            color: '#000',
            verticalAlign: 'center',
            rotate: 0,
            distance: 25,
            fontWeight: 'bold'
          }
        };

        const configs = {
          title: {
            text: groups[_id].title,
            left: 'center',
            textStyle: {
              fontSize: 24,
              fontWeight: 'bold'
            }
          },
          grid: { left: '12%', right: '12%', bottom: '16%' },
          animationDuration: 0,
          hoverAnimation: false,
          cursor: 'default',
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: { top: '13%' },
          xAxis: {
            data: [...groups[_id].labels],
            axisLabel: {
              fontSize: 24,
              fontWeight: 'bold'
            }
          },
          yAxis: {
            minInterval: groups[_id].received < 5 ? 1 : 0
          },
          series: [
            {
              name: 'ATD',
              type,
              barGap: 0,
              label,
              color: '#16df23',
              legendHoverLink: false,
              data: [...groups[_id].series.answered]
            },
            {
              name: 'PERD',
              type,
              label,
              color: '#da1616',
              data: [...groups[_id].series.lost]
            },
            {
              name: 'FILA',
              type,
              label,
              color: '#e9df20',
              data: [...groups[_id].series.queue]
            },
            {
              name: 'RING',
              type,
              label,
              color: '#4d94ff',
              data: [...groups[_id].series.ringing]
            },
            {
              name: 'ABND',
              type,
              label,
              color: '#e98f20',
              data: [...groups[_id].series.leaved]
            },
            {
              name: 'NATD',
              type,
              label,
              color: '#ef815d',
              data: [...groups[_id].series.notAnswered]
            },
            {
              name: 'MFILA',
              type,
              label,
              color: '#995c00',
              data: [...groups[_id].series.hqueued]
            }
          ]
        };
        const panel = document.getElementById(`panel_${props.el.i}`);
        let itemWidth = 0;
        if (panel) {
          const widthScreen = panel.offsetWidth;
          if (widthScreen < 1642 && widthScreen > 1104) {
            itemWidth = (widthScreen - 40) / 2;
          } else if (widthScreen < 1105) {
            itemWidth = widthScreen - 40;
          } else {
            itemWidth = (widthScreen - 40) / 3;
          }
        }
        return (
          <ReactEcharts
            key={i}
            option={configs}
            style={{ width: `${itemWidth}px`, height: '250px', float: 'left' }}
          />
        );
      })}
    </div>
  );
}

export default GraphGroups;

GraphGroups.propTypes = {
  el: PropTypes.object,
  reports: PropTypes.array
};
